import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { getAllUsers, createUser, updateItem, deleteItem } from "./UsersAxios";

// Get All Items From AXIOS API
export const GetALLUsers = createAsyncThunk(
  "user/get-all-users",
  async (thunkAPI) => {
    try {
      return getAllUsers();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// Create Item from AXIOS API
export const CreateUser = createAsyncThunk(
  "user/create",
  async (data, thunkAPI) => {
    try {
      return createUser(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// Update Item from AXIOS API
export const UpdateItem = createAsyncThunk(
  "user/update",
  async (data, thunkAPI) => {
    try {
      return updateItem(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// Delete Item from AXIOS API
export const DeleteItem = createAsyncThunk(
  "user/delete",
  async (id, thunkAPI) => {
    try {
      return deleteItem(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

const initialState = {
  users: false,
  isLoading: false,
  isSuccess: false,
  isAllUsersSuccess: false,
  isError: false,
  message: "",
  item: false,
  show: false,
};

// Country Slice .............
export const usersSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setItem: (state, { payload }) => {
      state.item = payload;
    },
  },

  extraReducers: (builder) => {
    builder

      // Get all Status
      .addCase(GetALLUsers.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(GetALLUsers.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isAllUsersSuccess = true;
        state.isError = false;
        state.users = action.payload?.data;
      })
      .addCase(GetALLUsers.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.isAllUsersSuccess = false;
        state.isError = true;
      })

      // Add User
      .addCase(CreateUser.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(CreateUser.fulfilled, (state) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.isAllUsersSuccess = false;
        if (state.isSuccess) {
          toast.success("Added 1 Successfully");
        }
      })
      .addCase(CreateUser.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.isError = true;
        state.isAllUsersSuccess = true;
        state.message = action.error;
        if (state.isError) {
          toast.error("Created Failed");
        }
      })

      // Update Status
      .addCase(UpdateItem.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(UpdateItem.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.updated = !state.updated;
        if (state.isSuccess) {
          toast.success("Updated Successfully");
        }
      })
      .addCase(UpdateItem.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.isError = true;
        state.message = action.error;
        if (state.isError) {
          toast.error("Updated Failed");
        }
      })

      // Deleted Item Status
      .addCase(DeleteItem.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(DeleteItem.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.deleted = !state.deleted;
        if (state.isSuccess) {
          toast.success("Deleted 1 Successfully");
        }
      })
      .addCase(DeleteItem.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.isError = true;
        state.message = action.error;
        if (state.isError) {
          toast.error("Deleted Failed");
        }
      })
      .addCase(resetStateCountry, () => initialState);
  },
});

export const resetStateCountry = createAction("Reset_all");
export default usersSlice.reducer;
export const { setItem } = usersSlice.actions;
